import { render, staticRenderFns } from "./addRootCategoryl.vue?vue&type=template&id=f1c7cfd0&scoped=true"
import script from "./addRootCategoryl.vue?vue&type=script&lang=js"
export * from "./addRootCategoryl.vue?vue&type=script&lang=js"
import style0 from "./addRootCategoryl.vue?vue&type=style&index=0&id=f1c7cfd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c7cfd0",
  null
  
)

export default component.exports